<template>
	
<div class="card-foot-stat-value" :data-type="type" :class="{'is-invalid': invalid}">

	<slot></slot>

	<template v-if="invalid">n/a</template>

</div>

</template>

<script>

export default {

	props: ['type', 'invalid']

}

</script>

<style scoped>

.card-foot-stat-value {
	height: 32px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 100%;
}

.card-foot-stat-value[data-type="text"] {
	font-size: 14px;
	font-weight: 500;
}

.card-foot-stat-value.is-invalid {
	color: #ccc;
    font-weight: 400;
    line-height: 32px;
    text-align: center;
    font-size: 14px
}

</style>
